import { FC, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Checkbox, FormControlLabel, Svg, SvgAction, TextField, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

interface FilterSectionProps {
  defaultValue: string;
  handleSearch: (searchValue: string) => void;
}

export const UserFilterSection: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Container>
      <UserSearch
        defaultValue={searchParams.get('search') || ''}
        handleSearch={(searchValue) =>
          setSearchParams({
            search: searchValue,
            locationId: searchParams.get('locationId') || '',
            showDeactivated: searchParams.get('showDeactivated') || 'false',
          })
        }
      />
      <ShowDeactivatedUsers
        defaultValue={searchParams.get('showDeactivated') || 'false'}
        handleSearch={(showDeactivatedValue) =>
          setSearchParams({
            search: searchParams.get('search') || '',
            locationId: searchParams.get('locationId') || '',
            showDeactivated: showDeactivatedValue,
          })
        }
      />
    </Container>
  );
};

const UserSearch: FC<FilterSectionProps> = ({ defaultValue, handleSearch }) => {
  const ref = useRef<HTMLInputElement>(null);
  const [search, setSearch] = useState<string>();

  const handleSearchParams = (e) => {
    if (e.key === 'Enter' || e.code === 'Enter' || e.key === 13) {
      handleSearch(e.target.value);
      e.target.blur();
    }
  };

  useEffect(() => {
    setSearch(defaultValue);
  }, [defaultValue]);

  return (
    <TextField
      inputRef={ref}
      id="search-field"
      data-testid="search-nav-bar"
      size="medium"
      variant="outlined"
      InputProps={{
        startAdornment: (
          <Box mr={2}>
            <Svg icon="search" />
          </Box>
        ),
        endAdornment: (
          <div
            role="button"
            aria-label="Clear search"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key == ' ') {
                ref?.current ? (ref.current.value = '') : null;
                setSearch('');
                handleSearch('');
              }
            }}
            onClick={() => {
              ref?.current ? (ref.current.value = '') : null;
              setSearch('');
              handleSearch('');
            }}
          >
            <SvgAction icon="close" display={search ? '' : 'none'} />
          </div>
        ),
      }}
      value={search}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
      }}
      placeholder="Search all users"
      onKeyDown={handleSearchParams}
    />
  );
};

const ShowDeactivatedUsers: FC<FilterSectionProps> = ({ defaultValue, handleSearch }) => {
  return (
    <FormControlLabel
      value={defaultValue}
      control={
        <Checkbox
          color="primary"
          checked={defaultValue === 'true'}
          onChange={(e) => handleSearch(e.target.checked.toString())}
        />
      }
      label="Show Deactivated"
      labelPlacement="end"
    />
  );
};

const Container = styled(Box)`
  &.MuiBox-root {
    display: flex;
    align-items: center;
    grid-gap: 1rem;
    flex-direction: row;
    .MuiFormControl-root {
      width: 230px;
      ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
    `}
    }
    ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
    `}
    ${variables.mediaQuery.lessThan('tablet')`   
      justify-content: center;
  `}
  }
`;
